import React from 'react'
import About from "../../../assets/images/about-1.png"
import Line from "../../../assets/images/line.png"
import { Link } from 'react-router-dom'
import { config } from '../config'


const AboutSection = ({ data }) => {
    return (
        <div>
            <div id="rs-about" className="rs-about style1 bg1 pt-120 pb-120 md-pt-80 md-pb-70">
                <div className="container">
                    <div className="row y-middle d-flex align-items-center">
                        <div className="col-lg-6 md-mb-50 ">
                            <div className="about-images">
                                <img src={data[1]?.imageUrl} alt="images" style={{ objectPosition: "top" }}
                                    className='w-100 h-100 object-fit-contain' />
                                <div className="about-widget wow fadeInUp">
                                    <div className="about-style">
                                        <div className="services-desc">
                                            Leading Cleaning
                                            Agency Since 2001
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 pr-55 md-pr-15">
                            <div className="sec-title content">
                                <span className="sub-text">{data[1]?.subtitle}</span>
                                <h2 className="title">
                                    {data[1]?.title?.split(" ").slice(0, 3).join(" ")} <span>{data[1]?.title?.split(" ")[3]}</span> {data[1]?.title?.split(" ")[4]}
                                </h2>
                                <div className="line-img wow fadeInUp">
                                    <img src={Line} alt="Images" />
                                </div>
                                <div className="desc about pb-25" dangerouslySetInnerHTML={{ __html: data[1]?.description }}>

                                </div>
                                <div className="btn-part mt-4">
                                    <Link to={`${config.appUrl}about-us`} className="readon view read">Read More</Link>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AboutSection
